import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import BuildIcon from '@material-ui/icons/Build';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import DescriptionIcon from '@material-ui/icons/Description';
import DoneIcon from '@material-ui/icons/Done';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import RoomIcon from '@material-ui/icons/Room';
import SearchIcon from '@material-ui/icons/Search';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import UpdateIcon from '@material-ui/icons/Update';
import WorkIcon from '@material-ui/icons/Work';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { openBlob, sc } from 'src/utils/Common';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import ReturnDialogContent from '../../components/ReturnDialogContent';
import { text } from '../../modules/languages/index';
import { setTask } from '../../store/actions/taskActions';
import Answers from '../WorkOrder/Answers';
import FgsArama from './FgsCall';
import logger from 'src/utils/logger';
import InstallAttentionForm from 'src/components/InstallAttentionForm';

let MesafeSonuc = 0;

const useStyles = makeStyles(theme => ({
  root: {},
  avatarAtanan: {
    backgroundColor: red[500]
  },
  avatar1Atanan: {
    backgroundColor: green[500]
  },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px'
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButtonAtanan: {
    padding: 10
  },
  dividerAtanan: {
    backgroundColor: '#FF9800'
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  searchContainer: {
    padding: '6px 16px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    margin: '0px 0px'
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px'
  },
  selectBox: {
    flex: 1,
    height: '45px',
    backgroundColor: '#f8f9fa',
    padding: '0 12px',
    fontSize: '14px',
    border: '1px solid #eee'
  },
  searchBar: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f1f3f4',
    padding: '4px 12px',
    height: '45px'
  },
  actionButton: {
    padding: '10px',
    backgroundColor: '#f8f9fa'
  },
  refreshIcon: { color: '#FF9800' },
  restoreIcon: { color: '#d93025' }
}));

function Notifications({
  className,
  AtananIsler,
  handleRefresh,
  handleRefreshMain,
  loading,
  setTask
}) {
  const classes = useStyles();
  const [filter, setFilter] = useState('');
  const [stateDurum, setStateDurum] = useState('');
  const [FisNo, setFisNo] = useState('');
  const [selectedFisNo, setSelectedFisNo] = useState('');
  const [open, setOpen] = React.useState(false);
  const [openMontajSorular, setOpenMontajSorular] = React.useState(false);
  const [IadeOpen, setIadeOpen] = React.useState(false);
  const [IadeDialogContent, setIadeDialogContent] = React.useState('');
  const [confirmJob, setconfirmJob] = React.useState();
  const [confirmnewStatus, setconfirmnewStatus] = React.useState();
  const [Enlem, setEnlem] = useState('');
  const [Boylam, setBoylam] = useState('');
  // const [MesafeSonuc, setMesafeSonuc] = useState("");

  //MHTU-6778
  const [openCamasirMontajUyariSorulariPopUp, setOpenCamasirMontajUyariSorulariPopUp] = React.useState(false);
  const [camasirMontajUyariSurveyJson, setCamasirMontajUyariSurveyJson] = React.useState(null);
  const [camasirMontajUyariFisNo, setCamasirMontajUyariFisNo] = React.useState('');
  const [camasirMontajUyariFormTipi, setCamasirMontajUyariFormTipi] = React.useState(null);
  const [camasirMontajUyariLoading, setCamasirMontajUyariLoading] = React.useState(false);
  const [camasirMontajUyariFormData, setCamasirMontajUyariFormData] = React.useState(null);
  //MHTU-6778

  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.'
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [loadingIOT, setLoadingIOT] = useState(false);
  const history = useHistory();
  const [filteredIsler, setFilteredIsler] = useState(
    Array.isArray(AtananIsler) ? AtananIsler : []
  );

  // Component mounted kontrolü için ref
  const isMountedRef = React.useRef(true);

  // Component unmount olduğunda isMountedRef'i false yap
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const openMontajSorulari = () => {
    if (!selectedFisNo) {
      return;
    }
    axios
      .get(`getTekSeferdeMontajCevaplar/${selectedFisNo}`)
      .then(response => {
        if (isMountedRef.current && response.data.length > 0) {
          setOpenMontajSorular(true);
        }
      })
      .catch(error => {
        logger.error('Hata detayı:', error.message);
      });
  };

  const handleFgsAramaOpen = (event, AtananIsFisNo) => {
    setOpenFgsArama(true);
    setFisNo(AtananIsFisNo.toString());
  };
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  };
  const durumMap = new Map([
    [20, 'Başvuru'],
    [21, 'Teknisyende'],
    [22, 'Üstlendi'],
    [33, 'Başlandı'],
    [42, 'Yola Çıkıldı']
  ]);

  const MULTI_F_KLIMA_MONTAJ_CAGRISI_URUNLER = [
    42785,
    42786,
    42787,
    42788,
    42789,
    42790,
    42639,
    42791,
    41037,
    41038,
    41039,
    41040,
    41041,
    41042,
    41043,
    41044,
    44316,
    44317,
    44318,
    44319,
    44320,
    44321,
    44322,
    44323
  ];

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleChange = event => {
    setStateDurum(event.target.value);
  };
  const Kirmizi = {
    color: '#b2102f'
  };
  const Sari = {
    color: '#FF9800'
  };
  const Yesil = {
    color: '#357a38'
  };
  const Mavi = {
    color: '#007FFF'
  };
  const getRandevuColor = (Bas, Bit) => {
    var today = new Date();
    if (parseInt(today.getHours()) < parseInt(Bit) - 1) {
      return Yesil;
    } else if (
      parseInt(today.getHours()) < parseInt(Bit) &&
      parseInt(today.getMinutes()) <= 30
    ) {
      return Sari;
    } else {
      return Kirmizi;
    }
  };
  const getAvatar = AtananIs => {
    let Bas = AtananIs.RANDEVU_BASLANGIC?.substring(0, 2);
    let Bit = AtananIs.RANDEVU_BITIS?.substring(0, 2);
    if ([21, 22, 33, 42].indexOf(parseInt(AtananIs.DurumKodu)) === -1) {
      var Kontrol = '';
      var KontrolText = '';
      var KontrolText1 = '';
      if (AtananIs.RANDEVU_KAPANIS_KONTROL === 1) {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatar1Atanan}>
            <DoneIcon />
          </Avatar>
        );
      } else {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatarAtanan}>
            <ClearIcon />
          </Avatar>
        );
      }
      return (
        <Typography component="span" variant="h6" style={Sari}>
          {Kontrol}
          <br></br>
          {KontrolText}
          <br></br>
          {KontrolText1}
        </Typography>
      );
    }

    return (
      <Typography
        component="span"
        variant="h6"
        style={getRandevuColor(Bas, Bit)}
      >
        <div>
          {AtananIs.RANDEVU_BASLANGIC}
          <br></br>
          {AtananIs.RANDEVU_BITIS}
        </div>
      </Typography>
    );
  };

  const getIOT = AtananIs => {
    if (parseInt(AtananIs.HOMEWHIZ) === 0) {
      return <div></div>;
    } else {
      return (
        <div>
          {loadingIOT ? (
            <CircularProgress style={Mavi} status={'loading'} />
          ) : (
            <SettingsRemoteIcon
              style={Mavi}
              onClick={() => handleIOTClickOpen(AtananIs)}
            />
          )}
          <br />
          <br />
        </div>
      );
    }
  };

  const getDurum = AtananIs => {
    if (parseInt(AtananIs.FisNo) === 0) {
      return <div></div>;
    }
    if (AtananIs.DurumKodu === 21) {
      return (
        <ThumbUpIcon
          style={Kirmizi}
          onClick={() => handleClickOpen(AtananIs, 22)}
        />
      );
    } else if (AtananIs.DurumKodu === 22) {
      return (
        <EmojiTransportationIcon
          color="secondary"
          onClick={() => handleClickOpen(AtananIs, 42)}
        />
      );
    } else if (AtananIs.DurumKodu === 42) {
      return (
        <div>
          <ThumbUpIcon
            color="secondary"
            onClick={() => handleClickOpen(AtananIs, 22)}
          />
          <br />
          <br />
          <PlayCircleFilledWhiteIcon
            style={Yesil}
            onClick={() => handleClickOpen(AtananIs, 33)}
          />
        </div>
      );
    }
  };

  const handleIOTClick = AtananIs => {
    setLoadingIOT(true);
    var Barkod =
      AtananIs.KUL_MODEL_KODU +
      AtananIs.UYIL.toString()
        .substring(2, 4)
        .toString() +
      AtananIs.SERINO.toString().padStart(6, '0') +
      AtananIs.UDONEM.toString().padStart(2, '0') +
      '01';
    const configIOT = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .get(
        '/FileImportExport/ArtemisIOT/' + Barkod + '/' + AtananIs.FisNo,
        configIOT
      )
      .then(response => {
        if (!isMountedRef.current) return;
        if (response.data.type === 'text/plain') {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription:
              'Cihaza uzaktan bağlanılamadı. Lütfen daha sonra tekrar deneyiniz!...'
          });
          setUyariTip('error');
          setUyari(true);
        } else {
          openBlob(response.data, Barkod);
        }
        setLoadingIOT(false);
      })
      .catch(error => {
        if (!isMountedRef.current) return;
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription:
            'Cihaza uzaktan bağlanılamadı. Lütfen daha sonra tekrar deneyiniz!...'
        });
        setUyariTip('error');
        setUyari(true);
        setLoadingIOT(false);
        logger.error('Hata detayı:', error.message);
      });
  };

  const handleIade = (status, job, newStatus) => {
    if (status === '7') {
      setIadeOpen(false);
      setIadeDialogContent(
        <ReturnDialogContent
          status={'0'}
          handleIade={handleIade}
          job={job}
          newStatus={newStatus}
        />
      );
      statusUpdate(confirmJob, confirmnewStatus);
      handleUrunIadeAlınacak(0, job.FisNo, 1, job.TEKNISYEN_KODU);
    } else if (status === '4') {
      setIadeOpen(false);
      setIadeDialogContent(
        <ReturnDialogContent
          status={'0'}
          handleIade={handleIade}
          job={job}
          newStatus={newStatus}
        />
      );
      statusUpdate(confirmJob, confirmnewStatus);
      handleUrunIadeAlınacak(0, job.FisNo, 0, job.TEKNISYEN_KODU);
    } else {
      setIadeDialogContent(
        <ReturnDialogContent
          status={status}
          handleIade={handleIade}
          job={job}
          newStatus={newStatus}
        />
      );
    }
  };
  const handleConfirmEvet = (job, newStatus) => {
    if (
      newStatus === 33 &&
      [2, 3].includes(job.BAYI_DAGITIM_TIPI) &&
      [40718, 40719, 42965, 43213].includes(job.UST_GRUP_KODU)
    ) {
      confirmAlert({
        message:
          'Montaj yapacağınız ürün Google TV özellikli olduğundan kullanıcının oluşturmuş olduğu ya da sizin kullanıcı adına oluşturacğınız gmail hesabı ile kurulum yapınız',
        buttons: [
          {
            label: 'Tamam',
            onClick: () => {
              return;
            }
          }
        ]
      });
    }
    if (
      newStatus === 22 &&
      (job.BasvuruNedeni === 'ÇM-Sesli çalışıyor' ||
        job.BasvuruNedeni === 'ÇM-Sıkmada aşırı ses ve sarsıntı yapıyor')
    ) {
      confirmAlert({
        message:
          'Sesli çalışma şikayetleri için hizmet fişi eklerine tespit videosu ekleyiniz.',
        buttons: [
          {
            label: 'Tamam',
            onClick: () => {
              statusUpdate(confirmJob, confirmnewStatus);
              return;
            }
          }
        ]
      });
    }

    if (newStatus === 22) {
      openMontajSorulari();
    }

    if (newStatus === 33 && job.OKC_BLOKE_UYARI === 1) {
      confirmAlert({
        message:
          'Vuk557 kapsamında uygulama yüklemediği için pasif durumda bulunan üründür!',
        buttons: [
          {
            label: 'Tamam',
            onClick: () => {
              return;
            }
          }
        ]
      });
    }

    if (
      newStatus === 33 &&
      job.BasvuruNedeni === 'Online Satış-Sipariş İade Talepleri'
    ) {
      setIadeDialogContent(
        <ReturnDialogContent
          status={'0'}
          handleIade={handleIade}
          job={job}
          newStatus={newStatus}
        />
      );
      setIadeOpen(true);
    }
    if (
      newStatus === 22 &&
      job?.MODEL_KODU &&
      MULTI_F_KLIMA_MONTAJ_CAGRISI_URUNLER.includes(job.MODEL_KODU)
    ) {
      confirmAlert({
        message:
          'Montaj aşamasında ürün bağlantısı yapılmayan, boşta kalan çıkışlarda yer alan rakorlu tapalar ile servis vanası üzerinde yer alan diğer kör tapalar ilerleyen süreçte gaz kaçak sorunları ile karşılaşılmaması adına mutlaka kontrol edilerek KL_2025_144 nolu bültende tariflendiği gibi sıkılmalıdır.',
        buttons: [
          {
            label: 'Tamam',
            onClick: () => {
              statusUpdate(confirmJob, confirmnewStatus);
            }
          }
        ]
      });
    }
    if (
      newStatus === 22 &&
      job.BasvuruNedeni === 'Buzdolabı-Smart Fix (Akıllı Arıza)'
    ) {
      confirmAlert({
        message: `Smart Fix (Akıllı Arıza) özellikli ürünler kendini analiz edip otomatik şekilde hizmet talebi oluşturabilir ve yedek parça/malzeme siparişi yönlendirmesi yapabilir. 
         *Müşteriyi ziyaret etmeden önce ürün performans verilerini gösteren sağlık raporu Yetkili Servis Teknisyeni tarafından incelenmelidir.*Müşteriyi ziyaret edecek Yetkili Servis Teknisyeni, hizmet fişine hata ile ilgili atanan yedek parçaları yanında bulundurmalıdır.`,
        buttons: [
          {
            label: 'Tamam',
            onClick: () => {
              statusUpdate(confirmJob, confirmnewStatus);
            }
          }
        ]
      });
    } else {
      statusUpdate(confirmJob, confirmnewStatus);
    }
  };

  const handleUrunIadeAlınacak = (
    event,
    FisNo,
    iade_alindi_mi,
    TEKNISYEN_KODU
  ) => {
    axios
      .get(
        `SetArtemisUrunAlindiMi/${FisNo}/${iade_alindi_mi}/${TEKNISYEN_KODU}`
      )
      .then(() => { })
      .catch(error => {
        logger.error('Hata detayı:', error.message);
      });
  };

  const DeleteStartTask = () => {
    confirmAlert({
      message:
        'İşlem başladığında, telefonunuzdaki yerel veriler silinir ve merkezi sistemden yeniden alınır. Bu işlem, yerel veritabanındaki işlerin silinmesine neden olur. Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => removeBaslandiJob()
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleIOTClickOpen = AtananIs => {
    var Uyari =
      AtananIs.FisNo +
      ' fiş numaralı müşterimizin ' +
      AtananIs.KUL_MODEL_KODU +
      ' ' +
      AtananIs.MODEL +
      ' Ürününe uzaktan bağlanılıp sağlık verilerine ulaşılacaktır. Devam etmek istediğinizdne eminmisiniz?';
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleIOTClick(AtananIs)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleClickOpen = (job, newStatus) => {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    function error() {
      var Uyari = '';
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.FisNo} ${job.Musteri}`);
      if (parseInt(job.FisNo) === 0) {
        setConfirmTitle(`${job.Musteri}`);
        if (newStatus === 33) {
          setConfirmDescription(`Yemeğe çıkmak istiyor musunuz?`);
        }
        if (newStatus === 4) {
          setConfirmDescription(`Yemeği bitirmek istiyor musunuz?`);
        }
      } else {
        setConfirmDescription(
          `${Uyari} ${newStatusDesc} duruma almak istiyor musunuz?`
        );
      }
    }
    function success(position) {
      var X1 = job.ENLEM;
      var X2 = job.BOYLAM;
      var Uyari = '';
      var Y1 = '';
      var Y2 = '';
      Y1 = position.coords.latitude;
      Y2 = position.coords.longitude;
      setEnlem(Y1);
      setBoylam(Y2);
      var MesafeSonucAtanan = getDistanceFromLatLonInKm(X1, X2, Y1, Y2).toFixed(
        1
      );
      if (isNaN(MesafeSonucAtanan)) {
        MesafeSonuc = 0;
      } else {
        MesafeSonuc = MesafeSonucAtanan;
      }

      if (newStatus === 33 && parseInt(job.FisNo) > 0) {
        if (MesafeSonucAtanan > 100) {
          Uyari =
            'Müşteri evinden ' +
            Math.floor(MesafeSonucAtanan) +
            ' metre uzakta işi başlatmaya çalışıyorsunuz!!! İşi başlatmak istediğinize emin misiniz? Müşteri Enlem,Boylam:' +
            X1 +
            ',' +
            X2 +
            ' TeknisyenEnlem,Boylam: ' +
            Y1 +
            ', ' +
            Y2 +
            ' ';
        }
      }
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.FisNo} ${job.Musteri}`);

      if (parseInt(job.FisNo) === 0) {
        setConfirmTitle(`${job.Musteri}`);
        if (newStatus === 33) {
          setConfirmDescription(`Yemeğe çıkmak istiyor musunuz?`);
        }
        if (newStatus === 4) {
          setConfirmDescription(`Yemeği bitirmek istiyor musunuz?`);
        }
      } else {
        setSelectedFisNo(job.FisNo);
        setConfirmDescription(
          `${Uyari} ${newStatusDesc} duruma almak istiyor musunuz?`
        );
      }
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d * 1000;
  }
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  const statusUpdate = (job, newStatus) => {
    setOpen(false);
    setLoading2(true);
    const newStatusDesc = durumMap.get(newStatus);

    if (newStatus === 33) {
      const safeAtananIsler = Array.isArray(AtananIsler) ? AtananIsler : [];
      const baslananIsler = safeAtananIsler.filter(
        d =>
          parseInt(d.DurumKodu) === parseInt(33) &&
          parseInt(d.FisNo) !== parseInt(job.FisNo)
      );

      if (baslananIsler.length > 0) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription:
            'Başlandı durumundaki ' +
            baslananIsler[0]?.FisNo +
            ' numaralı fişinizin durumu değiştirilmeden değişiklik yapılamaz!...'
        });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }
    }
    if (newStatus === 42) {
      const yolaCikildiIsler = AtananIsler.filter(
        d =>
          parseInt(d.DurumKodu) === parseInt(42) &&
          parseInt(d.FisNo) !== parseInt(job.FisNo)
      );

      if (yolaCikildiIsler.length > 0) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription:
            'Yola Çıkıldı durumundaki ' +
            yolaCikildiIsler[0]?.FisNo +
            ' numaralı fişinizin durumu değiştirilmeden değişiklik yapılamaz!...'
        });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }

      const baslananIslerYolaCikildi = AtananIsler.filter(
        d =>
          parseInt(d.DurumKodu) === parseInt(33) &&
          parseInt(d.FisNo) !== parseInt(job.FisNo)
      );

      if (baslananIslerYolaCikildi.length > 0) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription:
            'Başlandı durumundaki ' +
            baslananIslerYolaCikildi[0]?.FisNo +
            ' numaralı fişinizin durumu değiştirilmeden değişiklik yapılamaz!...'
        });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }

      if (
        baslananIslerYolaCikildi.length <= 0 &&
        yolaCikildiIsler.length <= 0 &&
        parseInt(job.IlgiliFormFisNo) > parseInt(0) &&
        parseInt(job.IlgiliFormTipi) > parseInt(0)
      ) {
        confirmAlert({
          message:
            'Bu adreste keşif formu bulunmaktadır. Lütfen kontrol ediniz.',
          buttons: [
            {
              label: 'Tamam',
              onClick: () => {
                return;
              }
            }
          ]
        });
      }
    }

    var OperationDateParam = moment()
      .utcOffset('+03:00')
      .format('YYYY-MM-DD HH:mm:ss');

    if (isNaN(MesafeSonuc)) {
      MesafeSonuc = 0;
    }

    // 1. Koordinat ve Mesafe Kontrolü (Hata riskini azaltır)
    const safeEnlem = Enlem ? Enlem.toString() : '0';
    const safeBoylam = Boylam ? Boylam.toString() : '0';
    const safeMesafe = isNaN(MesafeSonuc) ? 0 : Math.floor(MesafeSonuc);

    const data = [
      {
        AppNr: job.BasvuruNo,
        ServicePaperId: job.FisNo,
        ServiceShopId: job.BIRIM_KODU,
        RequestStatus: newStatus,
        ResultNote: '',
        TechnicianId: job.TEKNISYEN_KODU,
        DeviceStatus: job.DurumKodu,
        Latitude: safeEnlem,
        Longitude: safeBoylam,
        OperationDate: OperationDateParam,
        MesafeSonuc: safeMesafe
      }
    ];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SetArtemisServicePaperStatusUpdate', data, config)
      .then(response => {
        if (!isMountedRef.current) return;

        let ResponseData =
          Array.isArray(response.data) && response.data.length > 0
            ? response.data[0]
            : response.data;

        if (!isMountedRef.current) return;
        setresponseMessage(ResponseData);

        if (ResponseData?.ErrorCode === '0') {
          if (!isMountedRef.current) return;
          setUyariTip('success');

          if (newStatus === 33 && parseInt(job.FisNo) > 0) {
            if (!isMountedRef.current) return;
            setTask({
              ...job,
              DurumKodu: newStatus,
              Durum: newStatusDesc,
              DURUM_KODU: newStatus
            });
            history.push(`/WorkOrder/${job.FisNo}/summary`);
          }
          if (
            newStatus === 22 &&
            parseInt(job.FisNo) > 0 &&
            job.KUL_MODEL_KODU === '7489470105' &&
            job.BasvuruNedeni !==
            'Türk Kahve Makinesi-Eksik Aksesuar/ Yedek Parça Satışı' &&
            job.BasvuruNedeni !== 'Telve Pro-Keşif' &&
            job.BasvuruNedeni !== 'Telve Pro-Kullanım Bilgisi Tekrarı' &&
            job.BasvuruNedeni !== 'Telve Pro-İade Kampanyası (30 gün içinde)' &&
            job.BasvuruNedeni !== 'Telve Pro-Performans Kontrol' &&
            job.BasvuruNedeni !== 'Telve Pro-Bakım Kampanyalı Ücretsiz' &&
            job.BasvuruNedeni !== 'Türk Kahve Makinesi-İlk Kullanım' &&
            job.BasvuruNedeni !== 'Telve Pro-Montaj' &&
            job.BasvuruNedeni !==
            'Kredi Paketi Cayma Talebi (14 gün içinde)-Telve Pro' &&
            job.BasvuruNedeni !== 'Telve Pro-Tamamlanmayan Montaj' &&
            job.BasvuruNedeni !== 'Telve Pro-Nakliye Montaj' &&
            job.BasvuruNedeni !==
            'Türk Kahve Makinesi-Emanet Ürün Mutabakatı' &&
            job.BasvuruNedeni !== 'Telve Pro-Nakliye' &&
            job.BasvuruNedeni !== 'Telve Pro-Emanet Ürün Mutabakatı'
          ) {
            if (!isMountedRef.current) return;
            setOpenModal(true);
          }
          if (
            newStatus === 22 &&
            parseInt(job.FisNo) > 0 &&
            job.KUL_MODEL_KODU === '8837651100'
          ) {
            if (!isMountedRef.current) return;
            setOpenModal2(true);
          }

          if (
            newStatus === 22 &&
            parseInt(job.FisNo) > 0 &&
            job.KUL_MODEL_KODU === '8837651200'
          ) {
            if (!isMountedRef.current) return;
            setOpenModal3(true);
          }

          let malzemeList = [];
          job.MALZEMELER.forEach(row => {
            malzemeList.push(row.MALZEME_STOK_NO);
          });

          if (
            newStatus === 33 &&
            parseInt(job.FisNo) > 0 &&
            malzemeList.includes('2858195530')
          ) {
            confirmAlert({
              message:
                'İşlem sonunda Elektronik kart değişimi yapılacaksa Hizmet tabı altında Çıkarılan arızalı kart ve yeni takılan sağlam kartın üzerindeki QR barkodun ilgili alana okutularak girilmesi gerekmektedir',
              buttons: [
                {
                  label: 'Tamam',
                  onClick: () => {
                    return;
                  }
                }
              ]
            });
          }

          if (shouldTryOpenCamasirMontajUyariSorulari(job, newStatus)) {
            openCamasirMontajUyariSorulariPopup(job);
          }

          if (!isMountedRef.current) return;
          setFilteredIsler(
            AtananIsler.map(item =>
              item.FisNo === job.FisNo
                ? {
                  ...item,
                  DurumKodu: newStatus,
                  Durum: newStatusDesc,
                  DURUM_KODU: newStatus
                }
                : item
            )
          );
          if (isMountedRef.current) {
            handleRefresh();
          }
        } else {
          if (!isMountedRef.current) return;
          setUyariTip('error');
        }
        if (!isMountedRef.current) return;
        setUyari(true);
        setOpen(false);
        setLoading2(false);
      })
      .catch(error => {
        if (!isMountedRef.current) return;
        let ErrorData = '';
        ErrorData =
          'Şu anda Offine çalışıyor yada Merkezi Sistemlerde bir sorun olabilir!... Lütfen tekrar göndermeyi deneyiniz!...';
        setresponseMessage({ ErrorCode: '1000', ErrorDescription: ErrorData });
        setUyariTip('error');
        setUyari(true);
        setOpen(false);
        setLoading2(false);
        logger.error('Hata detayı:', error.message);
      });
  };

  const handleClick = (event, AtananIs) => {
    window.open(
      process.env.REACT_APP_MAP_URL + AtananIs.ENLEM + ',' + AtananIs.BOYLAM
    );
    event.persist();
  };

  useEffect(() => {
    const list = Array.isArray(AtananIsler) ? AtananIsler : [];

    filter === ''
      ? setFilteredIsler(list)
      : setFilteredIsler(
        list.filter(
          item =>
            sc(item.Musteri, filter) ||
            sc(item.BASVURU_NOTU, filter) ||
            sc(item.FisNo, filter) ||
            sc(item.BasvuruNedeni, filter) ||
            sc(item.Mahalle, filter) ||
            sc(item.Telefon, filter) ||
            sc(item.Randevu, filter)
        )
      );
  }, [filter, AtananIsler]);

  useEffect(() => {
    const list = Array.isArray(AtananIsler) ? AtananIsler : [];
    stateDurum === ''
      ? setFilteredIsler(list)
      : setFilteredIsler(
        list.filter(item => sc(item.DurumKoduArama, stateDurum))
      );
  }, [stateDurum, AtananIsler]);

  const shouldTryOpenCamasirMontajUyariSorulari = (job, newStatus) => {
    if (!job) return false;

    const uygunBasvuruNedenleri = [
      'ÇM-Montaj',
      'Genel-Nakliye',
      'ÇM-Nakliye Montaj',
      'ÇM-Nakliye'
    ];
    console.log('Job bilgileri:', job);

    if ([22, 42].includes(Number(newStatus))
      && parseInt(job.FisNo) > 0
      && parseInt(job.UST_MODEL_KODU) == 18369
      && uygunBasvuruNedenleri.includes(job.BasvuruNedeni)) {
      return true;
    } else {
      return false;
    }
  };

  const openCamasirMontajUyariSorulariPopup = async job => {
    if (
      parseInt(job?.FisNo) < 1 ||
      !job?.KUL_MODEL_KODU ||
      !job?.BasvuruNedeni ||
      !job?.UST_MODEL_KODU
    ) {
      return;
    }

    try {
      setCamasirMontajUyariLoading(true);
      setCamasirMontajUyariSurveyJson(null);
      setCamasirMontajUyariFormData(null);

      const response = await axios.get(
        `/GetArtemisFormMontaj/${5011}/${job.FisNo}/${job.KUL_MODEL_KODU}`
      );

      if (!response.data) {
        return;
      }

      const parsedResponse =
        typeof response.data === 'string'
          ? JSON.parse(response.data)
          : response.data;

      const firstItem = Array.isArray(parsedResponse)
        ? parsedResponse[0]
        : parsedResponse;

      if (!firstItem) {
        return;
      }

      const surveyJsonRaw = firstItem.json || firstItem.Json;
      const formDataRaw = firstItem.FormData || firstItem.formData;

      if (!surveyJsonRaw || !formDataRaw) {
        return;
      }

      const surveyJson =
        typeof surveyJsonRaw === 'string'
          ? JSON.parse(surveyJsonRaw)
          : surveyJsonRaw;

      const formData =
        typeof formDataRaw === 'string'
          ? JSON.parse(formDataRaw)
          : formDataRaw;

      if (!surveyJson?.pages) {
        throw new Error('5011 form JSON formatı geçersiz.');
      }

      setCamasirMontajUyariSurveyJson(surveyJson);
      setCamasirMontajUyariFormData(formData);
      setCamasirMontajUyariFisNo(job.FisNo);
      setCamasirMontajUyariFormTipi(5011);
      setOpenCamasirMontajUyariSorulariPopUp(true);
    } catch (error) {
      setresponseMessage({
        ErrorCode: '1000',
        ErrorDescription:
          'Çamaşır Makinesi Kurulum Uyarı Onay Formu alınırken hata oluştu.'
      });

      setUyariTip('error');
      setUyari(true);

      logger.error('Çamaşır montaj uyarı formu alma hatası:', error.message);
    } finally {
      setCamasirMontajUyariLoading(false);
    }
  };

  const normalizeSurveyDataForArtemisForm = surveyData => {
    const normalizedData = {};

    Object.keys(surveyData || {}).forEach(key => {
      const value = surveyData[key];

      if (Array.isArray(value)) {
        normalizedData[key] = value.length === 1 ? value[0] : value.join(',');
      } else {
        normalizedData[key] = value;
      }
    });

    return normalizedData;
  };

  const handleCamasirMontajUyariFormComplete = survey => {
    setCamasirMontajUyariLoading(true);

    const normalizedSurveyData = normalizeSurveyDataForArtemisForm(survey.data);

    const formData = {
      ...(camasirMontajUyariFormData || {}),
      ...normalizedSurveyData
    };

    const data = {
      Data: formData,
      FormTipi: camasirMontajUyariFormTipi,
      FisNo: camasirMontajUyariFisNo
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SetArtemisForm', { jsonString: JSON.stringify(data) }, config)
      .then(response => {
        const responseData = response.data;

        if (responseData?.ErrorCode && responseData.ErrorCode !== '0') {
          setresponseMessage(responseData);
          setUyariTip('error');
          setUyari(true);
          return;
        }

        setresponseMessage({
          ErrorCode: '0',
          ErrorDescription:
            'Çamaşır Makinesi Kurulum Uyarı Onay Formu başarıyla kaydedildi.'
        });

        setUyariTip('success');
        setUyari(true);

        setOpenCamasirMontajUyariSorulariPopUp(false);
        setCamasirMontajUyariSurveyJson(null);
        setCamasirMontajUyariFormData(null);
        setCamasirMontajUyariFisNo('');
        setCamasirMontajUyariFormTipi(null);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: '1000',
          ErrorDescription:
            'Çamaşır Makinesi Kurulum Uyarı Onay Formu kaydedilirken hata oluştu.'
        });

        setUyariTip('error');
        setUyari(true);

        logger.error(
          'Çamaşır montaj uyarı formu kayıt hatası:',
          error.message
        );
      })
      .finally(() => {
        setCamasirMontajUyariLoading(false);
      });
  };

  return (
    <Paper style={{ backgroundColor: 'transparent' }} elevation={0}>
      <Backdrop className={classes.backdrop} open={loading || loading2}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Dialog
        open={openModal}
        // onClose={setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'“7489470105 - TKM 9961 B ÇİFT CEZVE İNDÜKSİYON TKM STARBUCKS'}
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenModal(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              Emanet ürün ihtiyacı olabilir. Starbucks firmasına ihtiyaç halinde
              mutlaka emanet ürün verilmelidir.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid item xs={6} align="right">
            <Button
              variant="contained"
              color="secondary"
              startIcon={<ThumbUpAltIcon />}
              onClick={() => setOpenModal(false)}
            >
              TAMAM
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModal2}
        // onClose={setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'“8837651100 - K-3700  Telve Pro Türk Kahve  Makinası'}
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenModal2(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              Emanet ürün ihtiyacı olabilir. İhtiyaç halinde mutlaka emanet ürün
              verilmesi gerekmektedir.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid item xs={6} align="right">
            <Button
              variant="contained"
              color="secondary"
              startIcon={<ThumbUpAltIcon />}
              onClick={() => setOpenModal(false)}
            >
              TAMAM
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModal3}
        // onClose={setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'8837651200 - BKK-2700 Keyf Profesyonel Türk Kahvesi Makinesi'}
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenModal3(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              Emanet ürün ihtiyacı olabilir. İhtiyaç halinde mutlaka emanet ürün
              verilmesi gerekmektedir.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid item xs={6} align="right">
            <Button
              variant="contained"
              color="secondary"
              startIcon={<ThumbUpAltIcon />}
              onClick={() => setOpenModal(false)}
            >
              TAMAM
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Paper className={classes.searchContainer}>
        {/* Üst Satır: Filtre ve Aksiyonlar */}
        <div className={classes.filterRow}>
          <Select
            value={stateDurum}
            onChange={handleChange}
            disableUnderline
            className={classes.selectBox}
            displayEmpty
          >
            <MenuItem value="">Tüm İş Emirleri</MenuItem>
            <MenuItem value="21">Teknisyende</MenuItem>
            <MenuItem value="22">Üstlendi</MenuItem>
            <MenuItem value="33">Başlandı</MenuItem>
            <MenuItem value="100">Bekleyen</MenuItem>
            <MenuItem value="200">Kapalı</MenuItem>
          </Select>

          <IconButton
            size="small"
            className={classes.actionButton}
            onClick={handleRefreshMain}
          >
            <UpdateIcon className={classes.refreshIcon} fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            className={classes.actionButton}
            onClick={DeleteStartTask}
          >
            <SettingsBackupRestoreIcon
              className={classes.restoreIcon}
              fontSize="small"
            />
          </IconButton>
        </div>

        {/* Alt Satır: Arama Girişi */}
        <Paper className={classes.searchBar}>
          <SearchIcon style={{ color: '#5f6368', fontSize: '20px' }} />
          <InputBase
            placeholder="Arama yapınız..."
            fullWidth
            style={{ marginLeft: '10px', fontSize: '15px' }}
            onChange={e => setFilter(e.target.value)}
          />
        </Paper>
      </Paper>
      <Card className={clsx(classes.root, className)}>
        <List>
          {Array.isArray(filteredIsler) &&
            filteredIsler
              .sort((a, b) => {
                return a.SIRA - b.SIRA;
              })
              .map(AtananIs => (
                <div key={AtananIs.FisNo}>
                  <ListItem>
                    <ListItemSecondaryAction
                      style={{ position: 'absolute', bottom: -40, right: 15 }}
                    >
                      {parseInt(AtananIs.DATAAI) === 1 && (
                        <AddAlertIcon style={{ color: 'red' }} />
                      )}
                    </ListItemSecondaryAction>
                    <ListItemAvatar>
                      <div>
                        {parseInt(AtananIs.PAKET) === 1 && (
                          <AccountTreeIcon color="primary" />
                        )}
                        {getIOT(AtananIs)}
                        {getAvatar(AtananIs)}
                        <br />
                        {getDurum(AtananIs)}
                      </div>
                    </ListItemAvatar>
                    <ListItemText>
                      {/* Kapsayıcı Alan (Kart İçeriği) */}
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.5
                        }}
                      >
                        {/* 1. MÜŞTERİ ADI VE FİŞ NO (Başlık Alanı) */}
                        <Typography
                          variant="h6"
                          component={RouterLink}
                          to={
                            AtananIs.FisNo > 0
                              ? `/WorkOrder/${AtananIs.FisNo}/summary`
                              : '#'
                          }
                          sx={{
                            textDecoration: 'none',
                            color: 'primary.main', // Tıklanabilir olduğu belli olsun
                            fontWeight: 'bold',
                            lineHeight: 1.2,
                            display: 'block' // Linkin tüm satırı kaplaması için
                          }}
                        >
                          {/* İsmi Düzenle: Küçük harfe çevir, baş harfleri büyüt */}
                          <span style={{ textTransform: 'capitalize' }}>
                            {AtananIs.Musteri?.split('(')[0]?.toLocaleLowerCase(
                              'tr-TR'
                            )}
                          </span>

                          {/* Fiş Numarası (Daha silik ve küçük) */}
                          {AtananIs.FisNo > 0 && (
                            <Typography
                              component="span"
                              variant="caption"
                              sx={{
                                color: 'text.secondary',
                                marginLeft: 1,
                                fontWeight: 'normal'
                              }}
                            >
                              ({AtananIs.FisNo})
                            </Typography>
                          )}
                          {AtananIs?.MALZEMELER?.length > 0 && (
                            <Typography
                              component="span"
                              variant="caption"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginLeft: 14,
                                color: '#007FFF', // Malzemeyi vurgulamak için turuncu tonu
                                fontWeight: 'bold'
                              }}
                            >
                              <BuildIcon
                                style={{ fontSize: 14, marginRight: 4 }}
                              />
                            </Typography>
                          )}
                        </Typography>

                        {/* 2. MÜŞTERİ TELEFONU (Varsa ismin altında göster) */}
                        {AtananIs.Musteri?.includes('(') && (
                          <Typography
                            variant="body2"
                            component={RouterLink}
                            to={
                              AtananIs.FisNo > 0
                                ? `/WorkOrder/${AtananIs.FisNo}/summary`
                                : '#'
                            }
                            sx={{
                              color: 'text.primary',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <span role="img" aria-label="telefon">
                              📞
                            </span>{' '}
                            {AtananIs?.Musteri?.split('(')[1].replace(')', '')}
                          </Typography>
                        )}

                        {/* 3. SORUN / BAŞVURU NEDENİ (Vurgulu Gösterim) */}
                        <Typography
                          variant="subtitle2"
                          component={RouterLink}
                          to={
                            AtananIs.FisNo > 0
                              ? `/WorkOrder/${AtananIs.FisNo}/summary`
                              : '#'
                          }
                          sx={{
                            color: 'error.main',
                            fontWeight: 'bold',
                            marginTop: 0.5
                          }}
                        >
                          {AtananIs.BasvuruNedeni}
                          {AtananIs.MusteriTipi && (
                            <span
                              style={{ color: '#666', fontWeight: 'normal' }}
                            >
                              {' '}
                              • {AtananIs.MusteriTipi}
                            </span>
                          )}
                        </Typography>

                        {/* 4. ADRES (Okunabilir, Gri Tonlu) */}
                        <Typography
                          variant="h6"
                          component={RouterLink}
                          to={
                            AtananIs.FisNo > 0
                              ? `/WorkOrder/${AtananIs.FisNo}/summary`
                              : '#'
                          }
                          sx={{ fontWeight: 'bold' }}
                        >
                          <span role="img" aria-label="konum">
                            📍
                          </span>{' '}
                          {AtananIs.Mahalle}{' '}
                          {AtananIs.ADRES ? `- ${AtananIs.ADRES}` : ''}
                        </Typography>

                        {/* 5. NOTLAR (Varsa Arka Planlı Uyarı Şeklinde) */}
                        {AtananIs.BASVURU_NOTU && (
                          <Box
                            sx={{
                              mt: 1,
                              p: 1,
                              bgcolor: '#FFF9F0', // Açık turuncu uyarı rengi
                              borderRadius: 1,
                              borderLeft: '4px solid #ff9800'
                            }}
                          >
                            <Typography
                              variant="caption"
                              style={{ color: '#000000' }}
                            >
                              {AtananIs.BASVURU_NOTU}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                      <div style={{ marginTop: 10 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={2}>
                            {parseInt(AtananIs.FisNo) > 0 ? (
                              <PhoneInTalkIcon
                                color="secondary"
                                onClick={event =>
                                  handleFgsAramaOpen(event, AtananIs.FisNo)
                                }
                              ></PhoneInTalkIcon>
                            ) : (
                              AtananIs.DurumKodu === 22 && (
                                <FastfoodIcon
                                  style={Yesil}
                                  onClick={() => handleClickOpen(AtananIs, 33)}
                                ></FastfoodIcon>
                              )
                            )}
                            {//Eğer Atanan işin eşleştiği keşif formu ve form tipi varsa bu kısım çalışıyor
                              parseInt(AtananIs.IlgiliFormFisNo) > 0 &&
                              parseInt(AtananIs.IlgiliFormTipi) > 0 && (
                                <DescriptionIcon
                                  style={Yesil}
                                  onClick={() =>
                                    confirmAlert({
                                      message:
                                        'Eşleşen keşif formuna gitmek istediğinize emin misiniz?',
                                      buttons: [
                                        {
                                          label: 'Evet',
                                          onClick: () => {
                                            history.push(
                                              `/Form/${AtananIs.IlgiliFormTipi}/${AtananIs.IlgiliFormFisNo}`
                                            );
                                          }
                                        },
                                        {
                                          label: 'Hayır',
                                          onClick: () => {
                                            return;
                                          }
                                        }
                                      ]
                                    })
                                  }
                                ></DescriptionIcon>
                              )}
                          </Grid>
                          <Grid item xs={1} align="right"></Grid>
                          <Grid item xs={7} align="center">
                            <Typography
                              variant="h6"
                              style={{
                                fontFamily: 'Arcelik',
                                fontWeight: 'bold'
                              }}
                            >
                              {AtananIs.Durum}
                            </Typography>
                          </Grid>
                          <Grid item xs={2} align="right">
                            {parseInt(AtananIs.FisNo) > 0 ? (
                              <RoomIcon
                                color="secondary"
                                onClick={event => handleClick(event, AtananIs)}
                              ></RoomIcon>
                            ) : (
                              AtananIs.DurumKodu === 33 && (
                                <WorkIcon
                                  style={Kirmizi}
                                  onClick={() => handleClickOpen(AtananIs, 4)}
                                ></WorkIcon>
                              )
                            )}
                          </Grid>
                        </Grid>
                      </div>
                    </ListItemText>
                    <ListItemSecondaryAction>
                      {parseInt(AtananIs.FisNo) > 0 && (
                        <Tooltip title="Detayları Göster">
                          <IconButton
                            color="primary"
                            component={RouterLink}
                            to={`/WorkOrder/${AtananIs.FisNo}/summary`}
                            edge="end"
                            size="small"
                          >
                            <ArrowForwardIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.dividerAtanan} />
                </div>
              ))}
        </List>
      </Card>
      <FgsArama
        onClose={handleFgsAramaClose}
        FisNo={FisNo}
        open={openFgsArama}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ConfirmTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <br />
          <Typography component="h6" gutterBottom>
            {ConfirmDescription}
          </Typography>
          <br />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<ThumbUpAltIcon />}
                onClick={() => {
                  handleConfirmEvet(confirmJob, confirmnewStatus);
                }}
              >
                Evet
              </Button>
            </Grid>
            <Grid item xs={6} align="right">
              <Button
                variant="contained"
                color="secondary"
                startIcon={<ThumbDownAltIcon />}
                onClick={() => setOpen(false)}
              >
                Hayır
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMontajSorular}
        onClose={() => setOpenMontajSorular(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {text('Montaj_Uygunluk')}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Answers FisNo={selectedFisNo} readonly={true} />
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setOpenMontajSorular(false)}
            color="primary"
            autoFocus
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={IadeOpen}
        onClose={() => setIadeOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Ürün İadesi</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>{IadeDialogContent}</DialogContentText>
        </DialogContent>
      </Dialog>
      <InstallAttentionForm
        open={openCamasirMontajUyariSorulariPopUp}
        title="Çamaşır Makinesi Kurulum Uyarı Onay Formu"
        surveyJson={camasirMontajUyariSurveyJson}
        loading={camasirMontajUyariLoading}
        onComplete={handleCamasirMontajUyariFormComplete}
      />
    </Paper>
  );
}

Notifications.propTypes = {
  className: PropTypes.string
};

// export default Notifications;

export default connect(state => ({ loading: state.tasks1.loading }), {
  setTask
})(Notifications);
